import { Icon } from '@chakra-ui/react';

export default function AlarmClockCheckIcon(props) {
  return (
    <Icon
      width='48px'
      height='48px'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M10 6L4 12M44 12L38 6M12.76 37.4L8 42M35.28 37.34L40 42M18 26L22 30L30 22M40 26C40 34.8366 32.8366 42 24 42C15.1634 42 8 34.8366 8 26C8 17.1634 15.1634 10 24 10C32.8366 10 40 17.1634 40 26Z'
        stroke='currentColor'
        strokeWidth='4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Icon>
  );
}
